import { render, staticRenderFns } from "./usersPage.vue?vue&type=template&id=907c79b0&scoped=true"
import script from "./usersPage.vue?vue&type=script&lang=js"
export * from "./usersPage.vue?vue&type=script&lang=js"
import style0 from "./usersPage.vue?vue&type=style&index=0&id=907c79b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907c79b0",
  null
  
)

export default component.exports